import { useCallback, useEffect, useMemo, useState } from 'react'
import { scrollElementIntoView } from 'utils'

interface IScrollIntoViewOptions {
  behavior?: ScrollBehavior
  block?: ScrollLogicalPosition
  inline?: ScrollLogicalPosition
}

export const useScrollIntoView = (options: IScrollIntoViewOptions = {}) => {
  const [node, setNode] = useState<HTMLElement | null>(null)

  const scrollOptions = useMemo(
    () => ({
      behavior: 'smooth' as const,
      block: 'center' as const,
      inline: 'nearest' as const,
      ...options
    }),
    [options]
  )

  const scrollToNode = useCallback(() => {
    if (node) {
      scrollElementIntoView(node, scrollOptions)
    }
  }, [node, scrollOptions])

  useEffect(() => {
    scrollToNode()
  }, [scrollToNode])

  return { setNode, node }
}
